import React, { useContext, useEffect, useState } from "react";
import { apiPut, apiDelete, apiGet } from "../../../utils/apiFetch";
import apiPath from "../../../utils/apiPath";
import { isEmpty } from "lodash";
import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillDelete, AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import helper from "../../../utils/helpers";
import { Link, NavLink, useNavigate } from "react-router-dom";
import AuthContext from "context/AuthContext";
import dayjs from "dayjs";
import Pagination from "pages/Pagination";
// import ReplyModal from "./replyModal";
import { MdMessage } from "react-icons/md";

const BusinessExperts = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const notification = useToastContext();
  const { logoutUser, user } = useContext(AuthContext);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [queries, setAllQueries] = useState([]);
  const [showModal, setShowModal] = useState(false)
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [item, setItem] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [filterData, setFilterData] = useState({
    status: "",
    searchKey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sortKey: "createdAt",
    sortType: "desc",
  });
  const manager =
    user?.permission?.find((e) => e.manager === "customers") ?? {};

  function Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  const handelStatusChange = async item => {
    try {
      const payload = {
        status: item?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.expertStatusChange}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        allExperts()
      }
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }

  const handelDelete = async (item) => {
    try {
      const path = apiPath.expertDelete + "/" + item?._id;
      const result = await apiPut(path);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allExperts()
      } else {
        notification.error(result.data.message);
      }
    } catch (error) {
      console.log("error in get all FAQs list==>>>>", error.message);
    }
  };


  const allExperts = async (data) => {
    try {
      const { status, searchKey, isFilter } = filterData;
      const payload = {
        page,
        pageSize,
        status,
        keyword: searchKey.trim(),
        sortKey: sort.sortKey,
        sortType: sort.sortType,
      };

      const path = apiPath.expertsList;
      const result = await apiGet(path, payload);
      if (result?.status === 200) {
        const response = result?.data?.results;
        const resultStatus = result?.data?.success;
        setAllQueries(response?.docs);
        setPaginationObj({
          ...paginationObj,
          page: resultStatus ? response.page : null,
          pageCount: resultStatus ? response.totalPages : null,
          perPageItem: resultStatus ? response?.docs.length : null,
          totalItems: resultStatus ? response.totalDocs : null,
        });
      }
    } catch (error) {
      console.log("error ", error);
      setPaginationObj({});
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser();
      }
    }
  };

  const handleSearchKey = (e) => {
    setFilterData({ ...filterData, searchKey: e.target.value, isFilter: true });
    setPage(1);
  };

  const handleReset = () => {
    setFilterData({
      status: "",
      searchKey: "",
      startDate: "",
      endDate: "",
      isReset: true,
      isFilter: false,
    });
    setPage(1);
    setIsDelete(true);
  };
  const statusPage = (e) => {
    setFilterData({ ...filterData, status: e.target.value, isFilter: true });
    setPage(1);
    setIsDelete(true);
  };

  const toggleModal = (item) => {
    setShowModal(!showModal)
    setItem(item ?? {})
  }

  useEffect(() => {
    allExperts();
  }, [page, filterData, sort]);

  return (
    <div className="p-3">
      <div className="grid 2xl:grid-cols-2 py-3">
        <div className="flex flex-wrap  items-center">
          <div className="flex items-center lg:pt-0 pt-3 flex-wrap justify-start">
            <div className="flex items-center md:justify-end mb-2">
              <label
                htmlFor="default-search"
                className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
              >
                {t("O_SEARCH")}
              </label>
              <div className="flex">
                <div className="relative ">
                  <div className="absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none">
                    {!filterData?.searchKey && (
                      <svg
                        aria-hidden="true"
                        className="w-4 h-4 text-[#A5A5A5] dark:text-gray-40"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                    )}
                  </div>
                  <input
                    type="search"
                    id="default-search"
                    className="block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[250px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder={t("O_SEARCH_BY_NAME")}
                    value={filterData?.searchKey}
                    title=""
                    required
                    onChange={(e) => handleSearchKey(e)}
                  />
                </div>
              </div>
            </div>
            <div className="flex items-center ml-3">
              <select
                id="countries"
                type=" password"
                name="floating_password"
                className="block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                placeholder=" "
                value={filterData?.status}
                onChange={(e) => statusPage(e)}
              >
                <option defaultValue value="">
                  {t("O_ALL")}
                </option>
                <option value="active">{t("O_ACTIVE")}</option>
                <option value="inactive">{t("O_INACTIVE")}</option>
              </select>
            </div>
            <button
              type="button"
              onClick={handleReset}
              className="bg-LightBlue text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2"
            >
              {t("O_RESET")}
            </button>
          </div>
        </div>
        <div className='flex items-center 2xl:justify-end pl-0 2xl:pl-4 px-4'>
              {(manager?.add ||
                user?.role==='admin') && (
                  <button
                    title={t('O_ADD_NEW')}
                    type='button'
                    className='bg-LightBlue flex text-sm px-8 2xl:ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                    // onClick={() => setShowModal(true)}
                    onClick={(() => { navigate('/consultation-manager/experts/add') })}
                  >
                    {t('O_ADD_NEW')}
                  </button>
              )}
              </div>
      </div>
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-2">
                #
              </th>
              <th
                scope="col"
                className="py-3 px-2 cursor-pointer"
                onClick={() => {
                  if (
                    sort.sortKey === "name" &&
                    sort.sortType === "asc"
                  ) {
                    setSort({
                      sortKey: "name",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "name",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex ">
                  <span>{t("O_NAME")} </span>
                  <span>
                    {sort.sortKey === "name" &&
                      sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sortKey === "name" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-2 text-right">
                <div className="text-left">
                  <span>{t("O_EXPERTISE")}</span>
                </div>
              </th>
              <th scope="col" className="py-3 px-2 text-right">
                <div className="text-right">
                  <span>{t("O_EXPERIENCE")}</span>
                </div>
              </th>
              <th scope="col" className="py-3 px-2 text-right">
                <div className="text-right">
                  <span>{t("O_WHATSAPP_NUMBER")}</span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2 cursor-pointer"
                onClick={() => {
                  if (
                    sort.sortKey === "createdAt" &&
                    sort.sortType === "asc"
                  ) {
                    setSort({
                      sortKey: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "createdAt",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-end">
                  <span>{t("O_CREATED_AT")}</span>
                  <span>
                    {sort.sortKey === "createdAt" &&
                      sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sortKey === "createdAt" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-2 text-center">
                {t("O_STATUS")}
              </th>
              <th scope="col" className="py-3 px-2 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {queries &&
              queries?.map((item, i) => (
                <tr
                  key={i}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  {/* <td className='py-2 px-2 border-r text-right'>
                    {item?.userUniqueId}
                  </td> */}
                  <td className="py-2 px-2 border-r">
                    {item?.name}
                  </td>
                  <td className="py-2 px-2 border-r text-left">
                    {item?.categoryDetails?.title}
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {item?.experience}
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {item?.whatsAppNumber}
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {helper.dateFormat(item?.createdAt)}
                  </td>
                  {(manager?.add || user?.role === 'admin') && (
                    <td className='py-2 px-2 border-r text-center'>
                      <label
                        className='inline-flex relative items-center cursor-pointer'
                        title={`${
                          item?.status === 'active' ? 'Active' : 'Inactive'
                        }`}
                      >
                        <input
                          type='checkbox'
                          className='sr-only peer'
                          checked={item?.status === 'active'}
                          onChange={e =>
                            helper.alertFunction(
                              `${t('ARE_YOU_SURE')} ${
                                e.target.checked ? t('O_ACTIVE_SMALL') : t('O_INACTIVE_SMALL')
                              } ${item.name}`,
                              item,
                              handelStatusChange
                            )
                          }
                          // onChange={(e) => handelStatusChange(item)(e)}
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                      </label>
                    </td>
                  )}
                  <td className="py-2 px-2 border-l">
                    <div className="">
                      <ul className="flex justify-center">
                        <>
                          <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                            <NavLink
                            title={t('O_VIEW_USER')}
                            to='/consultation-manager/experts/view'
                            state={{ ...item }}
                            >
                              {" "}
                              <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                            </NavLink>
                          </li>
                          {(manager?.add || user?.role === "admin") && (
                            <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                            <NavLink
                            title="Edit"
                            to='/consultation-manager/experts/edit'
                            state={{ ...item }}
                            >
                              {" "}
                              <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                            </NavLink>
                          </li>
                        )}
                        {(manager?.delete || user?.role === "admin") && (
                          <li 
                            onClick={(e) =>
                              helper.alertFunction(
                                `${t('ARE_YOU_SURE_TO_DELETE_EXPERT')}`,
                                item,
                                handelDelete,
                                true
                              )
                            }
                            // onClick={() => handelDelete(item)}
                            className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                          >
                            <a title={t("O_DELETE")}>
                              {" "}
                              <AiFillDelete className="w-5 h-5 text-red-600" />{" "}
                            </a>
                          </li>
                        )}
                        </>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(queries) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-2 px-2 border-r" colSpan={9}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
        {paginationObj?.totalItems ? (
          <Pagination
            handlePageClick={handlePageClick}
            options={paginationObj}
            isDelete={isDelete}
            page={page}
          />
        ) : null}
      </div>
      <>
      {/* {showModal && <ReplyModal show={showModal} onHide={toggleModal} allExperts={allExperts} editData={item}  setPage={setPage}/>} */}
      </>
    </div>
  );
};

export default BusinessExperts;
